var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77895 9.24429C8.33754 9.62995 7.62432 9.62929 7.18235 9.23968L3.40208 5.90725C2.3278 4.98526 3.9396 3.60196 5.01388 4.52394L6.32162 5.65034C6.6194 5.90682 6.86079 5.81981 6.86079 5.46036V0.975711C6.86079 0.436874 7.3723 6.10352e-05 8.00041 6.10352e-05C8.6298 6.10352e-05 9.14003 0.439814 9.14003 0.975711V5.46036C9.14003 5.82176 9.38143 5.90677 9.67909 5.65034L10.9866 4.52394C12.0612 3.60196 13.6726 4.98526 12.5984 5.90725L8.77895 9.24429Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7143 11.7359C13.7143 11.9165 13.5439 12.0629 13.334 12.0629H2.66596C2.45596 12.0629 2.28571 11.9201 2.28571 11.7359V9.78077C2.28571 9.24062 1.77404 8.80273 1.14286 8.80273C0.511675 8.80273 0 9.24062 0 9.78077V12.7164C0 13.4332 0.683135 14.0189 1.52397 14.0189H14.476C15.3133 14.0189 16 13.4372 16 12.7164V9.78077C16 9.24062 15.4883 8.80273 14.8571 8.80273C14.226 8.80273 13.7143 9.24062 13.7143 9.78077V11.7359Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.96c4f5b3.svg";
export { ForwardRef as ReactComponent };